<template>
  <div class="student-item" @click="$emit('select')">
    <div v-if="mode === 'select'" class="icon">
      <i class="anyteachicon anyteach-check-circle" :class="selected ? 'selected' : 'default'" />
    </div>
    <div class="left">
      <h1>
        <i v-if="data.gender === 1" class="anyteachicon anyteach-male boy" />
        <i v-else class="anyteachicon anyteach-female girl" />
        <span>{{ data.name }} {{ data.name_eng }}</span>
      </h1>
      <h2>{{ data.age}} 岁</h2>
    </div>
    <div class="right">
      <i @click.stop="$emit('edit')" class="grey anyteachicon anyteach-edit" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "mode", "selected"]
}
</script>

<style lang="scss" scoped>
.student-item {
  width: 100%;
  padding: 13px 13px;
  margin: 0 auto 5px auto;
  border-radius: 4px;
  background: white;
  border: $border;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .boy {
    color: $blue;
  }
  .girl {
    color: $red;
  }
  .grey {
    color: $black;
    opacity: 0.55;
  }
  .icon {
    padding-right: 10px;
    .selected {
      color: $blue;
    }
    .default {
      opacity: 0.2;
    }
  }
  .left {
    flex-grow: 1;
  }
  h1 {
    font-size: 1rem;
    line-height: 1.5;
    margin: 0;
    font-weight: bold;
    i {
      margin: 0 3px 0 0;
    }
  }
  h2 {
    font-size: 0.8rem;
    font-weight: 400 !important;
    line-height: 1.2;
    padding: 0 !important;
    margin: 0;
    opacity: 0.6;
  }

  .top {
    width: 100%;
    padding: 0 15px 5px 15px;
  }
}
</style>